/**
 * Master Inventory is not gated on the login role. Centific users are stored
 * as project_manager by default even when they are only a moderator on a
 * project (or have no projects). Access requires a real admin view or being
 * a PM on at least one project.
 */
export function canAccessMasterInventory({
  effectiveRole,
  hasProjectManagerMembership,
}: {
  effectiveRole?: string | null;
  hasProjectManagerMembership?: boolean | null;
}): boolean {
  if ((effectiveRole ?? '').toLowerCase() === 'admin') return true;
  return Boolean(hasProjectManagerMembership);
}
